<template>
  <div class="row mt-5">
    <div class="col-xl-5" v-if="checkForPermission(add_holiday_permission)">
      <public-holiday-form button_text="Add Holiday" @holidayAction="addHoliday"/>
    </div>
    <div class="col-xl-1"></div>
    <div class="col-xl-6">
      <TableLoading v-if="publicHolidays.page === 0"/>
      <data-table v-else :columns="columns" :rows="publicHolidays.objects">
        <template v-slot:actions="slotProps">
          <div class="button-items">
            <b-button v-if="checkForPermission(edit_holiday_permission)" v-b-modal.edit-holiday variant="success" size="sm" class="py-1 text-white" @click="selectHoliday(slotProps.row)">
              Edit
            </b-button>
            <b-button v-if="checkForPermission(delete_holiday_permission)" variant="danger" size="sm" class="py-1 text-white" @click="removeHoliday(slotProps.row.publicId)">
              Delete
            </b-button>
          </div>
        </template>
      </data-table>
      <b-modal
          id="edit-holiday"
          centered
          size="lg"
          hide-footer
          hide-header
          title-class="font-18">
        <div class="p-2">
          <h3>Edit Public Holiday</h3>
          <public-holiday-form button_text="Edit Holiday" :selected_holiday="selected_holiday" @holidayAction="editHoliday"/>
          <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-holiday')">Close</b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import PublicHolidayForm from "@/components/settings/public-holiday-form";
import DataTable from "@/components/data-table";
import {ALL_PUBLIC_HOLIDAYS} from "@/gql/system-settings";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";
export default {
name: "public-holiday-component",
  components: {TableLoading, DataTable, PublicHolidayForm},
  data(){
    return{
      selected_holiday: {},
      add_holiday_permission: permissions.add_holiday_permission,
      edit_holiday_permission: permissions.edit_holiday_permission,
      delete_holiday_permission: permissions.delete_holiday_permission,
      columns: [
        {
          field: 'publicHolidayName',
          label: 'Holiday Name'
        },
        {
          field: 'publicHolidayDate',
          label: 'Holiday Date'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
      publicHolidays: {
        page: 0,
        objects: []
      }
    }
  },
  apollo: {
    publicHolidays: {
      query: ALL_PUBLIC_HOLIDAYS,
      variables(){
        return {
          page: 1,
          perPage: 30
        }
      }
    }
  },
  methods: {
    ... mapActions({
      addPublicHoliday: 'settings/addNewPublicHoliday',
      updatePublicHoliday: 'settings/updatePublicHoliday',
      deletePublicHoliday: 'settings/deletePublicHoliday',
    }),
    async addHoliday(data){
      await this.addPublicHoliday(data).then(resp => {
        if(resp.publicId){
          this.updatePublicHolidayQuery()
          successToast(`${resp.publicHolidayName} added successfully`)
        }

      })
    },
    async editHoliday(data){
      data.id = this.selected_holiday.publicId
      await this.updatePublicHoliday(data).then(resp => {
        if(resp.publicId) {
          this.updatePublicHolidayQuery()
          successToast(`${resp.publicHolidayName} updated successfully`)
        }
      })
    },
    async removeHoliday(id){
      await this.deletePublicHoliday({'id': id}).then(resp => {
        if(resp.message){
          this.updatePublicHolidayQuery()
          successToast(`${resp.message}`)
        }
      })
    },
    selectHoliday(row){
      this.selected_holiday = row
    },
    updatePublicHolidayQuery(){
      this.$apollo.queries.publicHolidays.refetch()
    }
  }
}
</script>

<style scoped>

</style>
